<script setup>
import { ref, onMounted, onUnmounted } from "vue";

const props = defineProps({
  color: {
    default: "#858379",
  },
});

const iconSize = ref("15rem");

onMounted(() => {
  updateIconSize();
  window.addEventListener("resize", updateIconSize);
});

const updateIconSize = () => {
  if (window.innerWidth <= 576) {
    iconSize.value = "10rem";
  } else {
    iconSize.value = "15rem";
  }
};

onUnmounted(() => {
  window.removeEventListener("resize", updateIconSize);
});
</script>

<template>
  <db-icon
    id="my-travel"
    icon="my-travel"
    variant=""
    :style="{
      '--icon-font-size': iconSize,
      '--icon-font-family': 'icons-32-outline',
      '--icon-font-weight': 400,
      color: color,
    }"
    class="hydrated"
  ></db-icon>
</template>
